export {default} from './ProductChevronIcon.component';
